// extracted by mini-css-extract-plugin
export default {"error_page":"error-page_error_page__3GYu2","error_image":"error-page_error_image__FJ+bM"};